/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { FxIdDomainEntitiesDocumentsDocumentFromJSON, FxIdDomainEntitiesDocumentsDocumentToJSON, } from './FxIdDomainEntitiesDocumentsDocument';
/**
 * Check if a given object implements the FxIdWebFeaturesDocumentsGetAllDocumentsWithVersionsGetAllDocumentsWithVersionsResponse interface.
 */
export function instanceOfFxIdWebFeaturesDocumentsGetAllDocumentsWithVersionsGetAllDocumentsWithVersionsResponse(value) {
    if (!('Documents' in value) || value['Documents'] === undefined)
        return false;
    return true;
}
export function FxIdWebFeaturesDocumentsGetAllDocumentsWithVersionsGetAllDocumentsWithVersionsResponseFromJSON(json) {
    return FxIdWebFeaturesDocumentsGetAllDocumentsWithVersionsGetAllDocumentsWithVersionsResponseFromJSONTyped(json, false);
}
export function FxIdWebFeaturesDocumentsGetAllDocumentsWithVersionsGetAllDocumentsWithVersionsResponseFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'Documents': (json['Documents'].map(FxIdDomainEntitiesDocumentsDocumentFromJSON)),
    };
}
export function FxIdWebFeaturesDocumentsGetAllDocumentsWithVersionsGetAllDocumentsWithVersionsResponseToJSON(json) {
    return FxIdWebFeaturesDocumentsGetAllDocumentsWithVersionsGetAllDocumentsWithVersionsResponseToJSONTyped(json, false);
}
export function FxIdWebFeaturesDocumentsGetAllDocumentsWithVersionsGetAllDocumentsWithVersionsResponseToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'Documents': (value['Documents'].map(FxIdDomainEntitiesDocumentsDocumentToJSON)),
    };
}
//# sourceMappingURL=FxIdWebFeaturesDocumentsGetAllDocumentsWithVersionsGetAllDocumentsWithVersionsResponse.js.map